import adminRequest from "@/api/adminRequest";

export function getCertificates() {
    return adminRequest({
        url: `/certificates`,
        method: 'get',
    });
}

export function generateCertificates() {
    return adminRequest({
        url: `/certificates/generate`,
        method: 'get',
    });
}